import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { fetchCategory, fetchFacts } from "@/lib/api";
import { getCategoryProgress, resetCategoryProgress } from "@/lib/progress";
import Header from "@/components/Header";
import { ArrowLeft, RefreshCcw, Sparkles } from "lucide-react";

export default function Complete() {
  const { categoryId } = useParams();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const [cat, fs] = await Promise.all([
          fetchCategory(categoryId),
          fetchFacts(categoryId, { onlyTrue: true }),
        ]);
        setCategory(cat);
        setTotal(fs.length);
        const p = getCategoryProgress(categoryId);
        if (p.learned.length < fs.length) {
          // not actually complete, send back
          navigate(`/study/${categoryId}`, { replace: true });
        }
      } catch {
        // ignore
      }
    })();
  }, [categoryId, navigate]);

  const handleRestart = () => {
    resetCategoryProgress(categoryId);
    navigate(`/study/${categoryId}`);
  };

  return (
    <div className="min-h-screen bg-paper bg-grain relative">
      <Header />
      <main
        className="relative z-10 max-w-3xl mx-auto px-4 pt-16 md:pt-28 text-center"
        data-testid="complete-screen"
      >
        <div className="inline-flex items-center gap-2 px-4 h-9 rounded-full bg-[#e8eae3] text-[#2e4733] mb-8">
          <Sparkles size={14} />
          <span className="label-eyebrow text-[#2e4733]">Oturum tamamlandı</span>
        </div>

        <h1 className="font-serif-fact text-4xl md:text-5xl lg:text-6xl text-[#1c2723] leading-[1.1] tracking-tight">
          Tebrikler.
          <br />
          <span className="italic text-[#4a6741]">
            {total} bilgiyi okudunuz.
          </span>
        </h1>

        <p className="mt-8 text-[#5c635e] text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          {category?.name && (
            <>
              <em className="not-italic font-medium text-[#1c2723]">
                {category.name}
              </em>{" "}
              kategorisini bitirdiniz. Bir gün sonra tekrar etmeniz hatırlamayı
              %40&apos;a kadar artırır.
            </>
          )}
        </p>

        <div className="mt-12 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            data-testid="back-home"
            className="inline-flex items-center gap-2 h-12 px-6 rounded-full border border-[#e8eae3] text-[#1c2723] hover:bg-white transition-colors"
          >
            <ArrowLeft size={14} /> Kategorilere dön
          </Link>
          <button
            onClick={handleRestart}
            data-testid="restart-session"
            className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-[#2e4733] text-[#f5f6f2] hover:bg-[#1c2723] transition-colors"
          >
            <RefreshCcw size={14} /> Baştan başla
          </button>
        </div>

        <div className="mt-20 mx-auto h-px w-24 bg-[#d6d9ce]" />
        <p className="mt-6 label-eyebrow text-[#a3aba6]">
          Tek cümle · Tek nefes · Tek bilgi
        </p>
      </main>
    </div>
  );
}
